import React, { Component } from 'react';
import ItemHeader from 'semantic-ui-react';

//Semantic
import 'semantic-ui-css/semantic.min.css';
import {
    Segment,
    Item,
    Image
} from 'semantic-ui-react';

import './works.css';
// REDUX
import { connect } from 'react-redux';

import API from '../../../services/api';


const mapStateToProps = state => ({
    app: state.app,
    configfile: state.configfile
})

class ConnectedWorks extends Component{
    constructor(props){
        super(props)
    }

    render(){
        // TODO passer en en svg
        // let fileName = this.props.img.slice(0, -3) + "svg"
        let fileName = this.props.img
        return(
            <div>
            {
                this.props.pro ? (
                    <div>
                    {
                        this.props.pro ? (
                            <Segment textAlign='center' title={this.props.title} id={this.props.id} className='boxIconTravaux travauxPro'>
                                <label>Pro</label>
                                <Image id={this.props.id} title={this.props.title} centered src={ API.resourceURL +'/upload/iconsworks/'+fileName}/>
                                <Item.Header as='h4' className="iconTravauxTitle" id={this.props.id} title={this.props.title} >{this.props.title}</Item.Header>
                            </Segment>
                        ):(
                            <Segment inverted color='blue' textAlign='center' title={this.props.title}className='boxIconTravaux travauxBlue'>
                                <Image  title={this.props.title} centered src={ API.resourceURL +'/upload/iconsworks/'+fileName}/>
                                <Item.Header as='h4' className="iconTravauxTitle" title={this.props.title} >{this.props.title}</Item.Header>
                            </Segment>
                        )
                    }
                    </div>
                ):(
                    <Segment textAlign='center' title={this.props.title} id={this.props.id}className='boxIconTravaux travauxBlue'>
                        <Image id={this.props.id} title={this.props.title} centered src={ API.resourceURL +'/upload/iconsworks/'+fileName} className="svg"/>
                        <Item.Header as='h4' className="iconTravauxTitle" id={this.props.id} title={this.props.title} >{this.props.title}</Item.Header>
                    </Segment>
                )
            }
            </div>
        )
    }
}

const Works = connect(mapStateToProps)(ConnectedWorks);
export default Works;



// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/Works.jsx